import numeral from 'numeral';
export const transactionDetailsConfig = [{
  head: '',
  content: [{
    label: 'Sale date',
    apiKeyPath: 'purchaseDetails.saleDate'
  }, {
    label: 'Sale type',
    apiKeyPath: 'purchaseDetails.saleType'
  }, {
    label: 'Order ID',
    apiKeyPath: 'transactionId'
  }, {
    label: 'License ID',
    apiKeyPath: 'licenseId'
  }, {
    label: 'Entitlement number',
    apiKeyPath: 'appEntitlementNumber'
  }, {
    label: 'App name',
    apiKeyPath: 'addonName'
  }, {
    label: 'App key',
    apiKeyPath: 'addonKey'
  }]
}, {
  head: 'Customer info',
  content: [{
    label: 'Company',
    apiKeyPath: 'customerDetails.company'
  }, {
    label: 'Contact name',
    apiKeyPath: 'customerDetails.billingContact.name'
  }, {
    label: 'Contact email',
    apiKeyPath: 'customerDetails.billingContact.email'
  }, {
    label: 'Technical contact name',
    apiKeyPath: 'customerDetails.technicalContact.name'
  }, {
    label: 'Technical contact email',
    apiKeyPath: 'customerDetails.technicalContact.email'
  }]
}, {
  head: 'Revenue',
  content: [{
    label: 'Sale price',
    apiKeyPath: 'purchaseDetails.purchasePrice',
    format: amount => numeral(amount).format('$0,0.00')
  }, {
    label: 'Atlassian fee',
    // $FlowFixMe We know that this will always be transaction
    condition: transaction => numeral(transaction.purchaseDetails.purchasePrice - transaction.purchaseDetails.vendorAmount).format('$0,0.00')
  }, {
    label: 'Net revenue',
    apiKeyPath: 'purchaseDetails.vendorAmount',
    format: amount => numeral(amount).format('$0,0.00')
  }, {
    label: 'Tier',
    apiKeyPath: 'purchaseDetails.tier'
  }, {
    label: 'Hosting',
    apiKeyPath: 'purchaseDetails.hosting'
  }, {
    label: 'Billing period',
    apiKeyPath: 'purchaseDetails.billingPeriod'
  }]
}, {
  head: 'Customer location',
  content: [{
    label: 'Country',
    apiKeyPath: 'customerDetails.country'
  }, {
    label: 'Region',
    apiKeyPath: 'customerDetails.region'
  }]
}, {
  head: 'Maintenance period',
  content: [{
    label: 'Start date',
    apiKeyPath: 'purchaseDetails.maintenanceStartDate'
  }, {
    label: 'End date',
    apiKeyPath: 'purchaseDetails.maintenanceEndDate'
  }]
}, {
  head: 'Partner info',
  content: [{
    label: 'Partner name',
    apiKeyPath: 'partnerDetails.partnerName'
  }, {
    label: 'Partner type',
    apiKeyPath: 'partnerDetails.partnerType'
  }, {
    label: 'Billing contact name',
    apiKeyPath: 'partnerDetails.billingContact.name'
  }, {
    label: 'Billing contact email',
    apiKeyPath: 'partnerDetails.billingContact.email'
  }]
}];